import { useState } from 'react';
import { toast } from 'sonner';
import { useT } from '../../i18n';
import { requestPasswordReset } from '../../services';
import { firebaseEnabled } from '../../lib/firebase';
import { Modal } from './Modal';

export function ForgotPassword({ open, onClose }: { open: boolean; onClose: () => void }) {
  const t = useT();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  const send = async () => {
    if (!email.trim()) return;
    setBusy(true);
    await requestPasswordReset(email);
    setBusy(false);
    toast.success(t(firebaseEnabled ? 'login.linkSentLive' : 'login.linkSent', { email }));
    onClose();
  };

  return (
    <Modal open={open} title={t('login.forgotTitle')} onClose={onClose} testId="forgot-password-dialog">
      <p className="text-sm text-slate-600">{t(firebaseEnabled ? 'login.forgotBodyLive' : 'login.forgotBody')}</p>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('login.emailPlaceholder')}
        data-testid="forgot-password-email-input"
        className="mt-4 h-12 w-full rounded-xl border border-sc-line px-4 text-base focus:border-sc-teal focus:outline-none focus:ring-2 focus:ring-sc-teal/30"
      />
      <div className="mt-5 flex gap-3">
        <button type="button" onClick={onClose} data-testid="forgot-password-cancel" className="h-12 flex-1 rounded-xl border border-sc-line font-semibold text-slate-700 hover:bg-slate-50">
          {t('login.cancel')}
        </button>
        <button type="button" onClick={send} disabled={busy || !email.trim()} data-testid="forgot-password-send" className="h-12 flex-1 rounded-xl bg-sc-teal font-semibold text-white hover:bg-sc-teal-hover disabled:opacity-50">
          {t('login.sendLink')}
        </button>
      </div>
    </Modal>
  );
}
